import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { useTranslation } from "react-i18next";

type CloneSingleButtonProps = { onClick: VoidFunction };

export const CloneSingleButton = ({ onClick }: CloneSingleButtonProps) => {
  const { t } = useTranslation("bookingModule");
  return (
    <Tooltip content={t("bookings.clone.cloneAction")}>
      {({ ref, getReferenceProps }) => (
        <Button
          ref={ref}
          icon="duplicate"
          kind="secondary"
          {...getReferenceProps({ onClick, title: t("bookings.clone.cloneBooking") })}
        />
      )}
    </Tooltip>
  );
};
